import React from 'react';
import CalendarStyle_1 from './CalendarStyle_1/CalendarStyle_1';
import CalendarStyle_2 from './CalendarStyle_2/CalendarStyle_2';
import CalendarStyle_3 from './CalendarStyle_3/CalendarStyle_3';
import CalendarStyle_4 from './CalendarStyle_4/CalendarStyle_4';
import CalendarStyle_5 from './CalendarStyle_5/CalendarStyle_5';

//元素组件
export default class CalendarStyle extends React.Component {
    constructor(props) {
        super(props);   
    }

    render() {
        const { stylevalue } = this.props;
        let CalendarStyle=<div></div>;
        switch (stylevalue) {
            //视图切换-简约风格      
            case '1':CalendarStyle=<CalendarStyle_1 {...this.props}/>;break;
            //视图切换-红色风格      
            case '2':CalendarStyle=<CalendarStyle_2 {...this.props}/>;break;
            //视图切换-绿色风格      
            case '3':CalendarStyle=<CalendarStyle_3 {...this.props}/>;break;
            //视图切换-淡蓝色      
            case '4':CalendarStyle=<CalendarStyle_4 {...this.props}/>;break;
            //视图切换-蓝色风格      
            case '5':CalendarStyle=<CalendarStyle_5 {...this.props}/>;break;

            default:CalendarStyle=<CalendarStyle_1 {...this.props}/>;
        }
        return CalendarStyle;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/mycalendar/CalendarStyle/index.js